import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-[40vh] flex items-center justify-center text-slate-500">Učitavanje…</div>;
  }
  if (!user) return <Navigate to="/prijava" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
